function ProgressFreeCell({free, item}: any) {

    let seasonStrokeClass = ' seasonStrokeClass';

    return <>
        {(free[item].reward === 'gems') ?
        <div className={'progressRewardGem font-oswald-bold ' + seasonStrokeClass}>
            <div className={'progressRewardGemAmount'}>{free[item].amount}</div>
        </div>
        :
        <div></div>
    }
    </>
}

export default ProgressFreeCell;
